import React, { useState } from "react";
import { deleteAdmins, getAdmins, updateAdmins } from "../../../MyApi/admins";
import { useQuery } from "react-query";
import TableActions from "../../../Components/UI/table/TableActions";
import StatusBadge from "../../../Components/UI/statusBadge";
import Can from "../../../utils/can";
import CreateAdminModal from "../../../Components/system settings/storemodals/adminsmodal";
import DataTable from "../../../Components/UI/table/DataTable";
import i18next from "i18next";

const AdminsTab = () => {
  const [isModalOpen, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState("");
const user =JSON.parse(localStorage.getItem("user"))
const adminId = user.id
console.log('adminId', adminId)
  const adminsColumns = [
    { label: "المعرف", accessor: "id" },
    { label: "الاسم", accessor: "name" },
    { label: "الإيميل", accessor: "email" },
    { label: "الهاتف", accessor: "phone" },
        { label: "الدور", accessor: "role" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          deleteFn={adminId === row.id ?"": deleteAdmins}
          deletePermission={adminId === row.id ?"": "delete_admin"}
          id={row.id}
          editPermission={"update_admin"}
          togglePermission={ adminId === row.id ?"": "update_admin"}
          toggleMutationKey={"toggle-update-admin"}
          queryKey={"getAdmins"}
          toggleFn={(id, status) => updateAdmins({is_active: status, "_method": "PUT", lang: i18next.language}, i18next.language, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

  const { data, isLoading, refetch } = useQuery(
    ["getAdmins"],
    getAdmins,
  );
  
  const admins = data?.data?.admins || [];

  const openModal = (mode, id) => {
    setOpenModal(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = () => {
    setOpenModal(false);
    setModalId(null);
  };

  const handleAddClick = () => {
    openModal("add", null);
  };

  return (
    <div>
      <Can permission={"view_admin"}>
        <DataTable
          actionLabel={"إضافة مدراء"}
          onAddClick={handleAddClick}
          title={"المشرفين"}
          columns={adminsColumns}
          data={admins}
          isLoading={isLoading}
          createPermission={"create_admin"}
        />
      </Can>

      {isModalOpen && (
        <CreateAdminModal
          show={isModalOpen}
          onClose={closeModal}
          refetch={refetch}
          mode={modalMode}
          id={modalId}
        />
      )}
    </div>
  );
};

export default AdminsTab;